'use memo'

import { useState } from 'react'

export type ResultViewMode = 'card' | 'table'

interface UseResultViewModeResult {
  mode: ResultViewMode
  setMode: (mode: ResultViewMode) => void
}

/**
 * Card / table choice for the results.
 *
 * Session-only by design: plain state, not the URL or localStorage. The choice
 * is a way of reading one search, not a setting — it should not outlive the
 * page or turn a shared link into someone else's layout preference.
 */
export const useResultViewMode = (
  initial: ResultViewMode = 'card'
): UseResultViewModeResult => {
  'use memo'
  const [mode, setMode] = useState<ResultViewMode>(initial)
  return { mode, setMode }
}
